import React, { PureComponent } from 'react';
import TitleComponent from '../components/title/Title';

// components
import Main from '../pages/map';
import Rainfall from '../pages/rainfall';
import ImageRainfallisohyet from '../pages/rainfall/listImageRainfall/imageRainfallisohyet';
import Waterlevel from '../pages/waterLevel';
import Dam from '../pages/dam';
import DamLargeLists from '../pages/dam/lists/large/DamLargeLists';
import DamMediumLists from '../pages/dam/lists/medium/DamMediumLists';
import WaterQuality from '../pages/waterQuality';
import Storm from '../pages/storm';
import StormMeaning from '../pages/storm/lists/StormHistoryDataLists/StormMeaning';
import ForecastRainfall from '../pages/forecast/forecastRainfall';
import Risk from '../pages/risk';
import Wave from '../pages/forecast/forecastWave';
import Contact from '../pages/contact';
import About from '../pages/about';
import Intro from '../pages/intro';
import Private from '../pages/private';
import Radar from '../pages/radar';
import LangDemo from '../pages/langdemo';
import Pdpa from '../pages/pdpa';
import SituationInfographicBasin from '../pages/map/situation/SituationInfographicBasin';
import ThaidCallback from '../containers/Header/login/ThaIDCallback';
import EventWater from '../pages/reportwater';
import ReportWater from '../pages/reportwater/Report';
import FloodDay from '../pages/floodday';

const initPath = `/${process.env.REACT_APP_PATH}`;

// withTitle function
const withTitle = ({ component: Component, title }) => class Title extends PureComponent {
  render() {
    return (
      <>
        <TitleComponent title={title} />
        <Component {...this.props} />
      </>
    );
  }
};

// define components with title
const MainComp = withTitle({ component: Main, title: 'สถานการณ์น้ำในประเทศไทย' });
const RainfallComp = withTitle({ component: Rainfall, title: 'ปริมาณฝน' });
const ImageRainfallisohyetComp = withTitle({ component: ImageRainfallisohyet, title: 'ภาพisohyet' });
const WaterlevelComp = withTitle({ component: Waterlevel, title: 'ระดับน้ำ' });
const DamComp = withTitle({ component: Dam, title: 'แหล่งน้ำ' });
const DamLargeComp = withTitle({ component: DamLargeLists, title: 'แหล่งน้ำขนาดใหญ่' });
const DamMediumComp = withTitle({ component: DamMediumLists, title: 'แหล่งน้ำขนาดกลาง' });
const WaterQualityComp = withTitle({ component: WaterQuality, title: 'คุณภาพน้ำ' });
const RiskComp = withTitle({ component: Risk, title: 'พื้นที่สาธาณภัย' });
const StormComp = withTitle({ component: Storm, title: 'พายุ' });
const ForecastRainfallComp = withTitle({ component: ForecastRainfall, title: 'คาดการณ์ฝน' });
const WaveComp = withTitle({ component: Wave, title: 'คาดการณ์คลื่น' });
const AboutComp = withTitle({ component: About, title: 'เกี่ยวกับเรา' });
const PdpaComp = withTitle({ component: Pdpa, title: 'นโยบายการคุ้มครองข้อมูลส่วนบุคคล' });
const InfographComp = withTitle({ component: SituationInfographicBasin, title: 'อินโฟกราฟิกติดตามสถานการณ์ลุ่มน้ำ' });

// === routes config ====
const Routes = () => [
  {
    path: `${initPath}`,
    exact: true,
    component: MainComp,
  },
  {
    path: `${initPath}main`,
    exact: true,
    component: MainComp,
  },
  {
    path: `${initPath}rainfall`,
    exact: true,
    component: RainfallComp,
  },
  {
    path: `${initPath}rainfall/isohyet`,
    exact: true,
    component: ImageRainfallisohyetComp,
  },
  {
    path: `${initPath}radar`,
    exact: true,
    component: Radar,
  },
  {
    path: `${initPath}waterlevel`,
    exact: true,
    component: WaterlevelComp,
  },
  {
    path: `${initPath}dam`,
    exact: true,
    component: DamComp,
  },
  {
    path: `${initPath}dam/large`,
    exact: true,
    component: DamLargeComp,
  },
  {
    path: `${initPath}dam/medium`,
    exact: true,
    component: DamMediumComp,
  },
  {
    path: `${initPath}waterquality`,
    exact: true,
    component: WaterQualityComp,
  },
  {
    path: `${initPath}risk`,
    exact: true,
    component: RiskComp,
  },
  {
    path: `${initPath}storm`,
    exact: true,
    component: StormComp,
  },
  {
    path: `${initPath}storm/meaning`,
    exact: true,
    component: StormMeaning,
  },
  {
    path: `${initPath}forecast/rainfall`,
    exact: true,
    component: ForecastRainfallComp,
  },
  {
    path: `${initPath}wave`,
    exact: true,
    component: WaveComp,
  },
  {
    path: `${initPath}about`,
    exact: true,
    component: AboutComp,
  },
  {
    path: `${initPath}contact`,
    exact: true,
    component: Contact,
  },
  {
    path: `${initPath}intro`,
    exact: true,
    component: Intro,
  },
  {
    path: `${initPath}login`,
    exact: true,
    component: Private,
  },
  {
    path: `${initPath}lang_demo`,
    exact: true,
    component: LangDemo,
  },
  {
    path: `${initPath}pdpa`,
    exact: true,
    component: PdpaComp,
  },
  {
    path: `${initPath}infographic-basin-situation`,
    exact: true,
    component: InfographComp,
  },
  {
    path: `${initPath}thaid/callback`,
    exact: true,
    component: ThaidCallback,
  },
  {
    path: `${initPath}reportwater/events`,
    exact: true,
    component: EventWater,
  },
  {
    path: `${initPath}reportwater/reports/:eventId`,
    exact: true,
    component: ReportWater,
  },
  {
    path: `${initPath}floodday`,
    exact: true,
    component: FloodDay,
  },
];

export default Routes;
